<template>
  <el-container id="page-container">
    <el-header id="page-header" height="50px">
      <div class="page-header-left fl">
        <img style="width:28px;height:28px" src="@/assets/image/logo.png" />
        <span class="page-header-title">{{title}}-管理系统 V{{version}}</span>
      </div>
      <div class="page-header-right fr">
        <el-avatar icon="el-icon-user-solid" size="medium"></el-avatar>
        <el-dropdown class="page-header-user">
          <span class="el-dropdown-link">
            {{username}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item icon="el-icon-edit" @click="openChangePassword">修改密码</el-dropdown-item>
              <el-dropdown-item icon="el-icon-close" @click="quit">退出账号</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-dialog v-model="dialogVisible" title="修改密码" width="30%">
          <div>
            <el-form :model="user" :rules="rules" ref="formPassword" labelPosition="right" label-width="120px">
              <el-form-item label="用户名">
                <el-input class="form-text-input" v-model="user.name" readonly></el-input>
              </el-form-item>
              <el-form-item label="原密码" prop="oldPassword">
                <el-input class="form-text-input" v-model="user.oldPassword" placeholder="请输入原密码" show-password></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="password">
                <el-input ref="password" class="form-text-input" placeholder="请输入新密码" v-model="user.password" show-password></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="password2">
                <el-input ref="password" class="form-text-input" placeholder="请再次输入新密码" v-model="user.password2" show-password></el-input>
              </el-form-item>
            </el-form>
          </div>
          <template #footer>
            <span class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changePassword">确 定</el-button>
            </span>
          </template>
        </el-dialog>
      </div>
    </el-header>
    <el-container id="page-content">
      <el-aside id="page-content-menu" width="220px">
        <Menu></Menu>
      </el-aside>
      <el-main id="page-content-main">
        <Tabs></Tabs>
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" />
          </keep-alive>
        </router-view>
      </el-main>
    </el-container>
    <el-footer id="page-footer" height="40px">
      <p class="footer-text">版权所有 ©2021{{copyright}} 保留所有权利 北京京德致远科技有限公司出品</p>
    </el-footer>
  </el-container>
</template>

<script lang="ts">
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Menu from "@/components/Menu.vue";
import Tabs from "@/components/Tabs.vue";
import { MenuData } from "@/script/core/base/MenuData";
import bus from "@/script/core/util/Bus";
import { User } from "@/script/apps/system/entity/SystemEntity";
import { ElMessage, ElNotification } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";
import { ConfigService } from "@/script/apps/system/service/ConfigService";
import { AuthService } from "@/script/apps/system/service/AuthService";
import { DictService } from "@/script/apps/system/service/DictService";

@Options({
  components: {
    Menu,
    Tabs,
  },
})
export default class Home extends Vue {
  private title = "";
  private copyright = "";
  private version = "";

  private username = "";

  private user: User = {};

  private dialogVisible = false;

  private rules = {
    oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
    password: [{ required: true, message: "请输入新密码", trigger: "blur" }],
    password2: [
      { required: true, message: "请再次输入新密码", trigger: "blur" },
    ],
  };

  created() {
    this.username = store.getters.loginUser.name;
    this.user.id = store.getters.loginUser.id;
    this.user.name = store.getters.loginUser.name;

    const config = new ConfigService();
    config.loadValue("app-name").then((result: any) => {
      this.title = result.data.itemValue;
    });
    config.loadValue("copyright").then((result: any) => {
      this.copyright = result.data.itemValue;
    });
    config.loadValue("app-version").then((result: any) => {
      this.version = result.data.itemValue;
    });

    new DictService().init();
  }

  quit() {
    store.dispatch("changeLoginToken", "");
    store.dispatch("changeLoginUser", undefined);
    store.dispatch("changeLoginState", 0);

    sessionStorage.clear();

    this.$router.push("/login");
  }

  openChangePassword() {
    this.dialogVisible = true;
  }

  changePassword() {
    const self = this;
    (this.$refs.formPassword as any).validate((valid: boolean) => {
      if (valid) {
        if (this.user.password !== this.user.password2) {
          ElMessage.error("两次密码录入不一致，请重新录入！");
          return;
        }
        const userService = new UserService();
        userService.changePassword(
          this.user,
          function (result: any) {
            ElNotification({
              type: "success",
              title: "修改密码成功",
              message: "请您重新登录系统！",
            });
            self.dialogVisible = false;
            self.$router.push({ path: "/login" });
          },
          function (error: Error) {
            ElMessage.error("修改密码失败，失败原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
</script>
